import React from 'react';
import { connect } from 'react-redux';
import { isAuthenticated } from '../reducers/login';
import Router from './Router';
import Layout from '../components/Layout';
import ScrollToTop from 'react-router-scroll-top';
import { ToastContainer } from 'react-toastify';

const mapStateToProps = state => ({
  isAuthenticated: isAuthenticated(state.login),
});

const App = ({ isAuthenticated }) => (
  <ScrollToTop>
    <Layout>
      <Router isAuthenticated={isAuthenticated} />
    </Layout>
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={true}
      closeOnClick
      pauseOnHover
      className="toast-container"
      toastClassName="toast-default"
    />
  </ScrollToTop>
);

export default connect(mapStateToProps)(App);
